import classNames from "classnames";
import * as React from "react";
import { FieldError } from "react-hook-form";

import styles from "./FieldWrapper.module.scss";
export interface FieldWrapperProps {
  label?: string;
  required?: boolean | string;
  error?: string | FieldError;
  withError?: boolean;
  containerClassName?: string;
}

export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  label,
  required,
  error,
  withError,
  children,
  containerClassName,
}) => {
  return (
    <div className={classNames(styles.container, containerClassName)}>
      {label ? (
        <div className={styles.label}>
          {label} {required ? <span>*</span> : ""}
        </div>
      ) : null}
      {children}
      {withError ? (
        <div className={styles.error}>
          {typeof error === "string" ? error : error?.message}
        </div>
      ) : null}
    </div>
  );
};
